export default __webpack_public_path__ + "media/Close.75827afa.svg";